'use strict';

var React = require('react');

var SvgHashtagDecimalIcon = function SvgHashtagDecimalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.629 3.511a.75.75 0 0 1 .61.868l-.413 2.371h2.174a.75.75 0 0 1 0 1.5h-2.434l-.61 3.5h2.544a.75.75 0 0 1 0 1.5h-2.804l-.457 2.629a.75.75 0 1 1-1.478-.257l.413-2.372h-3.478l-.457 2.629a.75.75 0 1 1-1.478-.257l.413-2.372h-2.174a.75.75 0 0 1 0-1.5h2.434l.61-3.5h-2.544a.75.75 0 0 1 0-1.5h2.804l.457-2.628a.75.75 0 1 1 1.478.257l-.413 2.371h3.478l.457-2.628a.75.75 0 0 1 .868-.61Zm-2.195 8.239h-3.477l.609-3.5h3.477l-.609 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }));
};
SvgHashtagDecimalIcon.displayName = "HashtagDecimalIcon";

exports.SvgHashtagDecimalIcon = SvgHashtagDecimalIcon;
